type Config = {
  apiURL: string,
  hotelID: string,
  apiKey: string,
  lang: string[],
  stanPlatnosci: string,
  lokalPrzydzial : string,
  rezNr : string,
  telNr : string,
  przerwa: string, 
  kelnerBookFoto: string, 

  zasady1: string,
  zasady1Opis: string,
  zasady1Link: string,
  zasady1Zaznacz: string,
  zasady2: string,
  zasady2Opis: string,
  zasady2Link: string,
  zasady2Zaznacz: string,
  zasady3: string,
  zasady3Opis: string,
  zasady3Link: string,
  zasady3Zaznacz: string,

  ikonaPrzelewy24: string,

  dowozOkreg1: string,
  dowozOkreg2: string,
  dowozOkreg3: string,

  inPost: string,
};
let CONFIG: Config = {
  apiURL: 'https://vsc24.net/vscXyz', //https://vsc24.net/vscKelnerBook
  hotelID: 'kelner-TEST-1', //kelner-TEST
  apiKey: '12349',
  lang: ['en', 'pl', 'sk', 'cz', 'ru', 'de', 'ua'],
  stanPlatnosci: "",
  lokalPrzydzial : '',
  rezNr : '',
  telNr : '',
  przerwa: "0", 
  kelnerBookFoto: "0", 

  zasady1: "0",
  zasady1Opis: "",
  zasady1Link: "",
  zasady1Zaznacz: "0",
  zasady2: "0",
  zasady2Opis: "",
  zasady2Link: "",
  zasady2Zaznacz: "0",
  zasady3: "0",
  zasady3Opis: "",
  zasady3Link: "",
  zasady3Zaznacz: "0",

  ikonaPrzelewy24: "0",

  dowozOkreg1: "0",
  dowozOkreg2: "0",
  dowozOkreg3: "0",

  inPost: "0"
};

// npm install typings --global
// https://stackoverflow.com/questions/50488121/typescript-add-functions-to-window-with-d-ts-file

interface WindowInterface extends Window {
  config: Config;
}

let window2config = () => { // uruchamiane w App : render()
  var config: Config = (window as unknown as WindowInterface).config || {
    // gdy nie ma public/config.js, ustawiam na parametry z kompilacji - def. wyżej
    apiUrl: CONFIG.apiURL,
    hotelID: CONFIG.hotelID,
    apiKey: CONFIG.apiKey,
    lang: CONFIG.lang,
    stanPlatnosci: CONFIG.stanPlatnosci,
    lokalPrzydzial: CONFIG.lokalPrzydzial,
    rezNr: CONFIG.rezNr,
    telNr: CONFIG.telNr,
    przerwa: CONFIG.przerwa,
    kelnerBookFoto: CONFIG.kelnerBookFoto,

    zasady1: CONFIG.zasady1,
    zasady1Opis: CONFIG.zasady1Opis,
    zasady1Link: CONFIG.zasady1Link,
    zasady1Zaznacz: CONFIG.zasady1Zaznacz,
    zasady2: CONFIG.zasady2,
    zasady2Opis: CONFIG.zasady2Opis,
    zasady2Link: CONFIG.zasady2Link,
    zasady2Zaznacz: CONFIG.zasady2Zaznacz,
    zasady3: CONFIG.zasady3,
    zasady3Opis: CONFIG.zasady3Opis,
    zasady3Link: CONFIG.zasady3Link,
    zasady3Zaznacz: CONFIG.zasady3Zaznacz,

    ikonaPrzelewy24: CONFIG.ikonaPrzelewy24,

    dowozOkreg1: CONFIG.dowozOkreg1,
    dowozOkreg2: CONFIG.dowozOkreg2,
    dowozOkreg3: CONFIG.dowozOkreg3,

    inPost: CONFIG.inPost,
    
  }
  CONFIG.apiURL = config.apiURL;
  CONFIG.hotelID = config.hotelID;
  CONFIG.apiKey = config.apiKey;
  CONFIG.lang = config.lang;
  CONFIG.stanPlatnosci = config.stanPlatnosci;
  CONFIG.lokalPrzydzial = config.lokalPrzydzial;
  CONFIG.rezNr = config.rezNr;
  CONFIG.telNr = config.telNr;
  CONFIG.przerwa = config.przerwa;
  CONFIG.kelnerBookFoto = config.kelnerBookFoto;

  CONFIG.zasady1 = config.zasady1;
  CONFIG.zasady1Opis = config.zasady1Opis;
  CONFIG.zasady1Link = config.zasady1Link;
  CONFIG.zasady1Zaznacz = config.zasady1Zaznacz;
  CONFIG.zasady2 = config.zasady2;
  CONFIG.zasady2Opis = config.zasady2Opis;
  CONFIG.zasady2Link = config.zasady2Link;
  CONFIG.zasady2Zaznacz = config.zasady2Zaznacz;
  CONFIG.zasady3 = config.zasady3;
  CONFIG.zasady3Opis = config.zasady3Opis;
  CONFIG.zasady3Link = config.zasady3Link;
  CONFIG.zasady3Zaznacz = config.zasady3Zaznacz;

  CONFIG.ikonaPrzelewy24 = config.ikonaPrzelewy24;

  CONFIG.dowozOkreg1 = config.dowozOkreg1;
  CONFIG.dowozOkreg2 = config.dowozOkreg2;
  CONFIG.dowozOkreg3 = config.dowozOkreg3;

  CONFIG.inPost = config.inPost;
}

export { window2config }
export default CONFIG;
